import { createWebHashHistory, createRouter } from "vue-router";
import Private from "../components/Private.vue";
import Home from "../components/Home.vue";
import User from "../components/User.vue";
const routes = [
  { path: "/", component: Home },
  { path: "/private", component: Private },
  { path: "/user", component: User },
];

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = createRouter({
  routes, // (缩写) 相当于 routes: routes
  history: createWebHashHistory(process.env.BASE_URL),
});
export default router;
